import React from 'react';
import GitHubIcon from '@mui/icons-material/GitHub';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import Link from '@mui/material/Link';
import { Grid2 } from '@mui/material';

const linkStyle = (theme) => ({
    textDecoration: "none",
    color: theme.palette.text.light,
    fontSize: "0.9rem",
    textAlign: "left",
    '& svg': {
        verticalAlign: 'bottom',
    },
    '&:hover': {
        color: theme.palette.text.primary,
    }
});

export default function ReleaseMetadata(props) {
    const { release } = props;

    const clusterToSubdomain = { 'om-test': 'test-argo', 'collate-prod': 'test-engg-v2' };
    const targetName = clusterToSubdomain[release.deploy_target] ?? release.deploy_target;
    const deploy_target = {
        url: `https://${targetName}.getcollate.io`,
        friendly_name: targetName,
    };

    return (
        <Grid2 container spacing={1} mt={2}>
            <Grid2 size={6}>
                <Link sx={linkStyle} href={`https://github.com/open-metadata/OpenMetadata/tree/${release.openmetadata_branch}`}><GitHubIcon /> OpenMetadata branch {release.openmetadata_branch}</Link>
            </Grid2>
            <Grid2 size={6}>
                <Link sx={linkStyle} href={`https://github.com/open-metadata/OpenMetadata/compare/${release.source_branch}...${release.openmetadata_branch}`}><GitHubIcon /> OpenMetadata commits diff</Link>
            </Grid2>
            <Grid2 size={6}>
                <Link sx={linkStyle} href={`https://github.com/open-metadata/openmetadata-collate/tree/${release.collate_branch}`}><GitHubIcon /> Collate branch {release.collate_branch}</Link>
            </Grid2>
            <Grid2 size={6}>
                <Link sx={linkStyle} href={`https://github.com/open-metadata/openmetadata-collate/compare/${release.source_branch}...${release.collate_branch}`}><GitHubIcon /> Collate commits diff</Link>
            </Grid2>
            <Grid2 size={6}>
                <Link sx={linkStyle} href={deploy_target.url}><RocketLaunchIcon /> Deploying to {deploy_target.friendly_name}</Link>
            </Grid2>
        </Grid2>
    );
}